import ArrowRight from 'lucide-react/dist/esm/icons/arrow-right.mjs';
import LoaderCircle from 'lucide-react/dist/esm/icons/loader-circle.mjs';

const LABELS = {
  checking: 'Проверяем устройство',
  preparing: 'Готовим подтверждение',
  requesting: 'Подтвердите на устройстве',
  verifying: 'Проверяем подтверждение',
  deactivating: 'Отключаем подписку',
};

export function SubscribeButton({ active, flow, onClick, location = 'hero' }) {
  const busy = flow.phase !== 'idle';
  const label = busy
    ? LABELS[flow.phase]
    : active
      ? 'Защита подключена'
      : 'Подключить за 20 ₽/день';

  return (
    <button
      className={`subscribe-button subscribe-button--${location}`}
      type="button"
      onClick={onClick}
      disabled={busy}
      aria-busy={busy}
    >
      <span>{label}</span>
      {busy ? (
        <LoaderCircle className="subscribe-button__spinner" aria-hidden="true" />
      ) : (
        <ArrowRight aria-hidden="true" />
      )}
    </button>
  );
}
